import Modal from "semantic-ui-react/dist/commonjs/modules/Modal";
import Button from "semantic-ui-react/dist/commonjs/elements/Button";
import { ModalProps } from "semantic-ui-react/dist/commonjs/modules/Modal/Modal";
import React from "react";
import { ButtonsTranslation } from "i18n/components/Buttons/typing";
import { ButtonsTexts } from "i18n/components/Buttons";

import { ListOfBusinessProfilesFieldForPayments } from "containers/Pricing/card-plans/card-plans-checkout-modal/fields/ListOfBusinessProfilesFieldForPayments";
import BusinessProfileModel from "models/business-profiles/BusinessProfile";
import { PricingCardsTranslations } from "i18n/containers/Pricing/PricingCards/typing";
import { PricingCardsTexts } from "i18n/containers/Pricing/PricingCards";
import Dropdown from "semantic-ui-react/dist/commonjs/modules/Dropdown";
import { DropdownProps } from "semantic-ui-react/dist/commonjs/modules/Dropdown/Dropdown";
import { ProductKeys } from "containers/Pricing/products";
import { DropdownItemProps } from "semantic-ui-react/dist/commonjs/modules/Dropdown/DropdownItem";
import {useLocales} from "@libs";

const ChallengeCheckoutModal = (props: {
	modalProps: ModalProps;
	onClose: () => void;
	onPay: (event: any, businessProfile: BusinessProfileModel, quantity: number) => void;
	loading: boolean;
	pricePerUnit: number;
}) => {
	const { modalProps, onClose, onPay, loading, pricePerUnit } = props;
	const {currentShortLocale} = useLocales();
	const buttonTranslation: ButtonsTranslation = {
		...ButtonsTexts[currentShortLocale],
	};
	const pricingCardsTranslations: PricingCardsTranslations = {
		...PricingCardsTexts[currentShortLocale],
	};
	const [checkoutState, setCheckoutState] = React.useState({
		quantity: 1,
		quantityOptions: [] as DropdownItemProps[],
		businessProfile: BusinessProfileModel.generateEmpty(),
	});
	const handleOnSelectBusinessProfile = (businessProfile: BusinessProfileModel) => {
		setCheckoutState({
			...checkoutState,
			businessProfile,
		});
	};
	const handleOnChangeQuantity = (_: any, data: DropdownProps) => {
		setCheckoutState({
			...checkoutState,
			quantity: Number(data.value),
		});
	};
	const handleOnPay = (e: any) => {
		onPay(e, checkoutState.businessProfile, checkoutState.quantity);
	};
	const getFixedPrice = (fullPrice: number) => {
		return (Math.round(fullPrice * 100) / 100).toFixed(2);
	};

	React.useEffect(() => {
		const quantityOptions = [] as DropdownItemProps[];
		const getText = (numberOfChallenges: number) => {
			const unitText =
				numberOfChallenges > 1 ? pricingCardsTranslations.challengePlural : pricingCardsTranslations.challengeSingular;

			return `${numberOfChallenges} ${unitText}`;
		};

		for (let i = 1; i <= 10; i++) {
			quantityOptions.push({
				key: i,
				label: `US$${getFixedPrice(i * pricePerUnit)}`,
				text: getText(i),
				value: i,
			});
		}

		setCheckoutState({
			...checkoutState,
			quantityOptions,
		});
	}, []);

	return (
		<Modal
			size={"small"}
			{...modalProps}
		>
			<Modal.Header>Challenge Checkout</Modal.Header>
			<Modal.Content>
				<p>{pricingCardsTranslations.selectAmountOfChallenges}</p>
				<Dropdown
					fluid
					selection
					className="margin-1-bottom"
					options={checkoutState.quantityOptions}
					onChange={handleOnChangeQuantity}
					value={checkoutState.quantity}
				/>
				<p>{pricingCardsTranslations.selectBusinessProfile}</p>
				<ListOfBusinessProfilesFieldForPayments
					onSelectBusinessProfile={handleOnSelectBusinessProfile}
					typeOfProduct={ProductKeys.Challenges}
				/>
			</Modal.Content>
			<Modal.Actions>
				<Button
					basic
					onClick={onClose}
					loading={loading}
					disabled={loading}
				>
					{buttonTranslation.cancel}
				</Button>
				<Button
					positive
					onClick={handleOnPay}
					loading={loading}
					icon={"cart"}
					action={{
						color: "teal",
						labelPosition: "left",
						icon: "cart",
						content: "Checkout",
					}}
					actionPosition="left"
					content={buttonTranslation.continue}
					disabled={loading || !checkoutState.businessProfile.info.id}
				/>
			</Modal.Actions>
		</Modal>
	);
};

export default ChallengeCheckoutModal;
